import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
    selectShowContingenciesNotification,
} from '~Betslip/selectors/contingenciesSelectors';

import {
    selectShowPriceChangeNotification,
} from '~Betslip/selectors/notificationSelectors';

import {
    selectAnySelectionSuspended,
} from '~Betslip/selectors/selectionDetailsSelectors';

import './styles.scss';

import {
    selectShowDepositNotification,
} from '~Betslip/selectors/userSelectors';

import {
    isUserLoggedIn,
} from '~shared/utils/user';

const Notifications = () => {
    const [ t ] = useTranslation();
    const showContingenciesNotification = useSelector(selectShowContingenciesNotification);
    const showPriceChangeNotification = useSelector(selectShowPriceChangeNotification);
    const showSuspendedNotification = useSelector(selectAnySelectionSuspended);
    const showDepositNotification = useSelector(selectShowDepositNotification);

    const notification = (type, text) => {
        const classes = classNames(
            'fullslip__notification',
            `fullslip__notification--${type}`,
        );

        return (
            <p
                className={classes}
                data-test-id={`betslip;notification-${type}`}
            >
                {text}
            </p>
        );
    };

    const renderContingenciesNotification = () => {
        if (!showContingenciesNotification) {
            return null;
        }

        return notification(
            'contingency',
            t('betslip.contingency')
        );
    };

    const renderPriceChangeNotification = () => {
        if (!showPriceChangeNotification) {
            return null;
        }

        return notification(
            'odds-changed',
            t('betslip.price_update')
        );
    };

    const renderSuspendedNotification = () => {
        if (!showSuspendedNotification) {
            return null;
        }

        return notification(
            'suspended',
            t('betslip.suspended_notification')
        );
    };

    const renderDepositNotification = () => {
        if (isUserLoggedIn() && showDepositNotification) {

            return notification(
                'deposit',
                t('betslip.deposit_notification')
            );
        }

        return null;
    };

    return (
        <>
            {renderSuspendedNotification()}
            {renderPriceChangeNotification()}
            {renderContingenciesNotification()}
            {renderDepositNotification()}
        </>
    );
};

export default Notifications;
